import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

export const Container = styled.div`
  //ASK Change
  max-width: 319px;
  background-color: ${COLORS.white};
  display: flex;
  flex-direction: column;
  padding: ${SIZING.unit(3)} ${SIZING.unit(2)};
  width: 100%;
  gap: ${SIZING.unit(2)};
  @media ${device.tablet} {
    max-width: 456px;
    padding: ${SIZING.unit(3)} ${SIZING.unit(3.5)};
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    max-width: 234px;
  }
`;

export const AddressAutoCompleteContaniner = styled.div`
  position: relative;
`;

export const Overlay = styled.div`
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  padding: 0;
  z-index: 1000;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${device.tablet} {
  }
`;
